<template>
  <div id="multiactivity" v-wechat-title="$route.meta.title">
    <div class="wrap750">
      <welcome :src="multiactivity.cover"/>
      <div class="banner"><img :src="multiactivity.banner"></div>
      <div class="activity_name">{{multiactivity.name}}</div>
      <div class="description">
        <p v-for="(detail,index) in multiactivity.details.split('\n')" :key="index">{{ detail }}</p>
      </div>
      <div class="group" v-for="(category,index) in multiactivity.categories" :key="index">
        <div class="group_name">{{category.name}}</div>
        <a :href="activity.activityUrl" target="_blank" v-for="(activity,index) in category.activities" :key="index">
          <div class="album">
            <div class="album_padding">
              <div class="cover_bg">
                <img :src="activity.coverUrl">
              </div>
              <div class="album_info">
                <div class="album_name">{{activity.activityName}}</div>
                <div class="count">{{activity.photoCount}}张</div>
                <div class="viewer">{{activity.browseCount}}次查看</div>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  import '@/assets/css/global.sass'
  import Fetch from '@/assets/js/methods/Fetch';
  import welcome from '@/components/welcome.vue';
  import wx from 'weixin-js-sdk';

  export default {
    data: () => ({
      multiactivity:{
        cover:'',
        banner:'',
        title:'',
        details:'',
        categories:[
          {
            name:'',
            activities:[
              {
                activityUrl:':',
                coverUrl:"",
                activityName:'',
                photoCount:"",
                browseCount:''
              }
            ]
          }
        ]
      }
    }),
    components: {
      // banner,
      welcome,
      // 'activity-info': activityInfo,
    },
    methods: {
      wxinit(title, desc, coverUrl){ 
        this.$axios.get("/sign").then(({status, data}) => {
          if(status === 200 && data) {
            let param = {
              debug:false,
              url:window.location.href,
              jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline', 'onMenuShareQQ', 'onMenuShareQZone']
            }
            let param2=Object.assign(param,data)
            wx.config(param2);
            wx.ready(()=>{
              console.log('wx.ready');
              wx.onMenuShareTimeline({
                title: title, //
                desc: desc, //
                link: window.location.href, //
                imgUrl: coverUrl, // 
                success: function(res) {
                  //alert('分享成功'+shareImg)
                },
                cancel: function(res) {
                }
              });
              wx.onMenuShareAppMessage({
                title: title, // 
                desc: desc, //
                link: window.location.href, // 
                imgUrl: coverUrl, // 
                success: function(res) {
                  //alert('分享成功'+shareImg)
                },
                cancel: function(res) {
                }
              });
            });	
            wx.error(function(res){
              console.log('wx err',res);
            });
            }
       
         
        });
      },
      init(multiactivityId) {
        this.$axios.get("/api/multiactivity",{
          params:{
            multiactivityId
          }
        }).then(({status, data})=>{
          console.log(data)
          if (status === 200 && data) {
            //console.log(data)
            const {name, cover, details, wechatIcon, categories } = data.result.multiactivity
            this.$route.meta.title = name
            let wxCoverUrl = cover
            const wxTitle = name
            const wxDetails = details
            if(wechatIcon !== '') wxCoverUrl = wechatIcon
            wxCoverUrl = window.location.origin + wxCoverUrl
            wxCoverUrl = wxCoverUrl.replace('yun.cam-fi.com', 'yuncdn.cam-fi.com')
            console.log(wxCoverUrl)
            //微信初始化
            this.wxinit(wxTitle, wxDetails, wxCoverUrl)

            // let host = window.location.host
            // host = host.replace('yun.cam-fi.com', 'yuncdn.cam-fi.com')
            
            categories.forEach(category=>{
              category.activities.forEach(activity=>{
                activity.activityUrl = `http://yuncdn.cam-fi.com/activity/${activity.activityUrl}`
              })
            })

            this.multiactivity = data.result.multiactivity
          }
        }).catch((err)=>{
          console.log('error:',err)
        });
      }
    },
    mounted() {
      const multiactivityId=this.$route.params.id;
      this.init(multiactivityId)
    },
  }
</script>

<style scope>
    body {
        background-color: #e3e3e3;
        margin: 0;
        padding: 0;
    }

    img {
        width: 100%;
    }

    a {
        color: #000;
        cursor: pointer;
    }

    .wrap750 {
        max-width: 750px;
        margin: 0 auto;
        background-color: #f4f4f4;
        padding-bottom: 32px;
    }

    .group {
        overflow: auto;
        padding: 0 8px;
    }

    .activity_name {
        font-size: 20px;
        text-align: center;
        padding: 32px;
        font-weight: 500;
    }

    .description {
        background-color: #fff;
        padding: 16px;
        font-size: 14px;
        line-height: 28px;
    }

    .group_name {
        padding: 32px 8px 8px 8px;
        font-size: 18px;
    }

    .cover_bg {
        background-color: #fff;
        padding: 2px;
    }

    .album {
        max-width: 50%;
        float: left;
    }

    .album_padding {
        padding: 8px;
    }

    .album_info {
        background-color: #fff;
        overflow: auto;
    }

    .album_name {
        padding: 8px;
    }

    .count,
    .viewer {
        font-size: 12px;
        color: #555;
        padding: 8px;
    }

    .count {
        float: left;
    }

    .viewer {
        float: right;
    }

    @media screen and (max-width: 375px) {
        .activity_name {
            font-size: 18px;
            padding: 24px;
        }

        .description {
            margin: 0 8px;
            font-size: 13px;
            line-height: 20px;
            padding: 8px;
        }

        .album_padding {
            padding: 4px;
        }

        .group {

            padding: 0 4px;
        }

        .album_name {
            padding: 4px;
            font-size: 13px;
        }

        .count,
        .viewer {
            font-size: 10px;
            color: #555;
            padding: 4px;
        }

        .group_name {
            padding: 24px 0px 8px 4px;
            font-size: 16px;
        }
    }

    @media (min-width: 375px) and (max-width: 480px) {
        .activity_name {
            font-size: 18px;
            padding: 24px;
        }

        .description {
            margin: 0 8px;
            font-size: 13px;
            line-height: 22px;
            padding: 16px 8px;
        }

        .album_padding {
            padding: 4px;
        }

        .group {
            padding: 0 4px;
        }

        .album_name {
            padding: 4px;
            font-size: 14px;
        }

        .count,
        .viewer {
            font-size: 12px;
            color: #888;
            padding: 4px;
        }

        .group_name {
            padding: 24px 0px 8px 4px;
            font-size: 16px;
        }
    }
    </style>